var KV = new Swiper('.KV', {
	observer: true,
	observeParents: true,
	// slidesPerView: 0,
	spaceBetween: 0,
	loop: true,
	loopedSlides: 2,
	autoplay: {
		delay: 8000,
	},
	pagination: {
		el: '.swiper-pagination', //ページネーションの要素
		type: 'bullets', //ページネーションの種類
		clickable: true, //クリックに反応させる
	},
	navigation: {
		nextEl: ".swiper-button-next", // 次へボタン有効化
		prevEl: ".swiper-button-prev", // 前へボタン有効化
				disabledClass: 'k_swiper_disabled', 
	},
});

var ranking = new Swiper('.ranking-dog', {
	observer: true,
	observeParents: true,
	loop: true,
	slidesPerView: 2,
	// spaceBetween: 10,
	navigation: {
		nextEl: '.swiper-button-next-ranking-dog',
		prevEl: '.swiper-button-prev-ranking-dog',
				disabledClass: 'k_swiper_disabled', 
	},
	autoplay: {
		delay: 5000,
	},
	breakpoints: {
		769: {
			slidesPerView: 4,
		}
	}
});
var ranking = new Swiper('.ranking-cat', {
	observer: true,
	observeParents: true,
	loop: true,
	slidesPerView: 2,
	// spaceBetween: 10,
	navigation: {
		nextEl: '.swiper-button-next-ranking-cat',
		prevEl: '.swiper-button-prev-ranking-cat',
				disabledClass: 'k_swiper_disabled', 
	},
	autoplay: {
		delay: 5000,
	},
	breakpoints: {
		769: {
			slidesPerView: 4,
		}
	}
});
var ranking = new Swiper('.blog_dog_pc', {
	observer: true,
	observeParents: true,
	loop: true,
	slidesPerView: 1,
	spaceBetween: 16,
	navigation: {
		nextEl: '.swiper-button-next-blog_dog_pc',
		prevEl: '.swiper-button-prev-blog_dog_pc',
				disabledClass: 'k_swiper_disabled', 
	},
	autoplay: {
		delay: 5000,
	}
});
var ranking = new Swiper('.blog_dog_sp', {
	observer: true,
	observeParents: true,
	loop: true,
	slidesPerView: 1,
	allowTouchMove: true,
	simulateTouch: true,
	spaceBetween: 16,
	pagination: {
		el: '.swiper-pagination_dog_sp', //ページネーションの要素
		type: 'bullets', //ページネーションの種類
		clickable: true, //クリックに反応させる
	},
	navigation: {
		nextEl: '.swiper-button-next-blog_dog_sp',
		prevEl: '.swiper-button-prev-blog_dog_sp',
				disabledClass: 'k_swiper_disabled', 
	},
	autoplay: {
		delay: 5000,
	}
});
var ranking = new Swiper('.blog_cat_pc', {
	observer: true,
	observeParents: true,
	loop: true,
	slidesPerView: 1,
	allowTouchMove: true,
	simulateTouch: true,
	spaceBetween: 16,
	navigation: {
		nextEl: '.swiper-button-next-blog_cat_pc',
		prevEl: '.swiper-button-prev-blog_cat_pc',
	},
	autoplay: {
		delay: 5000,
	}
});
var ranking = new Swiper('.blog_cat_sp', {
	observer: true,
	observeParents: true,
	loop: true,
	slidesPerView: 1,
	allowTouchMove: true,
	simulateTouch: true,
	spaceBetween: 16,
	pagination: {
		el: '.swiper-pagination_cat_sp', //ページネーションの要素
		type: 'bullets', //ページネーションの種類
		clickable: true, //クリックに反応させる
	},
	navigation: {
		nextEl: '.swiper-button-next-blog_cat_sp',
		prevEl: '.swiper-button-prev-blog_cat_sp',
				disabledClass: 'k_swiper_disabled', 
	},
	autoplay: {
		delay: 5000,
	}
});

$(window).on('load', function () {
  if ($('body').attr('data-disable-scroll') === 'true') {
		console.log('Scroll skipped for brand page.');
		return;
	}
	var url = $(location).attr('href');
	if (url.indexOf("#") != -1) {
		var anchor = url.split("#");
		var target = $('#' + anchor[anchor.length - 1]);
		if (target.length) {
			var pos = Math.floor(target.offset().top) - 120;
			$("html, body").animate({ scrollTop: pos }, 500);
		}
	}
});

document.addEventListener("DOMContentLoaded", function () {
	document.querySelectorAll('.k_blog-swiper').forEach(function (slider) { 

		const slide_main = slider.querySelector(".k_blog-swiper_items"); 
		const mobileItems = parseInt(slider.dataset.mobile) || 1;
		const desktopItems = parseInt(slider.dataset.desktop) || 3;

		const k_blog_swiper = new Swiper(slide_main, {
			slidesPerView: mobileItems,
			spaceBetween: 16,
			observer: true,
			observeParents: true,
			allowTouchMove: true,
			simulateTouch: true,
			loop: true,
			navigation: {
				nextEl: slider.querySelector(".k_blog-button-next"),
				prevEl: slider.querySelector(".k_blog-button-prev"),
				disabledClass: 'k_swiper_disabled', 
			},
			pagination: {
				el: slider.querySelector('.swiper-pagination'),
				clickable: true,
			},
			breakpoints: {
				768: {
					spaceBetween: 50,
					slidesPerView: desktopItems
				}
			}
		});
	}); 
    
 
});


$(document).ready(function () {
	$('.top_search_title_area').click(function () {
		if ($(window).width() < 769) {
			$(this).toggleClass('active_item');
			$(this).siblings('.top_search_content_area').slideToggle();
		} else {
			$(this).siblings('.top_search_content_area').show();
		}
	});

	$('.gift-card-title-area').click(function () {
		if ($(window).width() < 769) {
			$(this).toggleClass('active_item');
			$(this).siblings('.gift_card_content').slideToggle();
		} else {
			$(this).siblings('.gift_card_content').show();
		}
	});
	$('.k_contact_btn').on('click', function () {
		const selected = $('input[name="k_contact_radio"]:checked').val();
		if (selected === 'product') {
			$('.k_c_first_popup').hide();
			$('.k_c_second_popup').fadeIn();
		} else if (selected === 'official') {
			$('.contact_popup_area').fadeOut();
			setTimeout(function () {
				$('.contact_popup_area').remove();
			}, 2000);
		}
	});

	$('.k_contact_close').on('click', function () {
			$('.contact_popup_area').fadeOut();
			setTimeout(function () {
				$('.contact_popup_area').remove();
			}, 2000);
	});
	// mega menu trigger 
 
 
}); 
document.querySelectorAll('.mega-menu-left-tab-style .mega_menu_title_trigger').forEach(function(trigger) {
  trigger.addEventListener('click', function () {
    const targetClass = this.getAttribute('data_menu_trigger');
    const container = this.closest('.mega-menu-left-tab-style');

    const triggers = container.querySelectorAll('.mega_menu_title_trigger');
    const contents = container.querySelectorAll('.menu_tab_content');

    // Remove active from all triggers
    triggers.forEach(function(t) {
      t.classList.remove('active');
    });

    // Add active to the clicked trigger
    this.classList.add('active');

    // Remove active_content from all content blocks
    contents.forEach(function(c) {
      c.classList.remove('active_content');
    });

    // Add active_content to the matching block
    const targetContent = container.querySelector('.' + targetClass);
    if (targetContent) {
      targetContent.classList.add('active_content');
    }
  });
});


$(document).ready(function() {
  $('.read_more_blog').on('click', function() {
    var $this = $(this);
    var $content = $this.siblings('.blog_content');

    // Toggle active class on .plus_minus
    $this.toggleClass('active');

    // Toggle content height
    if ($this.hasClass('active')) {
      $content.css({
        'height': $content.get(0).scrollHeight + 'px',
        'transition': 'height 0.3s ease'
      });
    } else {
      $content.css({
        'height': '50px',
        'transition': 'height 0.3s ease'
      });
    }
  });


	$('.k_tab_title_box label, .tab_area_rn label').on('click touchend', function () {
	setTimeout(function () {
		window.dispatchEvent(new Event('resize'));
		if (swiper) swiper.slideTo(swiper.activeIndex, 0, false); // Optional
	}, 100); // Delay helps especially on slower mobile UIs
	});
});
 
(function initYouTubeMoviePlayers() {
  const movieBlocks = document.querySelectorAll('.p-movie');
  const modal = document.querySelector('x-modal.collection_page_popoup');

  if (!movieBlocks.length) return;

  movieBlocks.forEach((block) => {
    const videoId = block.dataset.id;
    const cover = block.querySelector('.p-movie__inner__cover');
    const playArea = block.querySelector('.p-movie__inner__play');

    if (!videoId || !cover || !playArea) return;

    const playVideo = () => {
      // Only if not already playing
      if (playArea.querySelector('iframe')) return;

      cover.style.display = 'none';

      const iframe = document.createElement('iframe');
      iframe.width = '100%';
      iframe.height = '100%';
      iframe.frameBorder = '0';
      iframe.allow = 'autoplay; encrypted-media';
      iframe.allowFullscreen = true;
      iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;

      playArea.appendChild(iframe);
    };

    const resetVideo = () => {
      const iframe = playArea.querySelector('iframe');
      if (iframe) {
        playArea.removeChild(iframe);
        cover.style.display = '';
      }
    };

    cover.addEventListener('click', () => {
      // Only allow play if modal is either not present or is open
      if (!modal || modal.hasAttribute('open')) {
        playVideo();
      }
    });

    // If modal exists, observe its "open" attribute
    if (modal) {
      const observer = new MutationObserver(() => {
        if (!modal.hasAttribute('open')) {
          resetVideo(); // Reset all videos when modal is closed
        }
      });

      observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
    }
  });
})();
/*
document.addEventListener("DOMContentLoaded", function () {
  const cookieName = "onetrust_closed";

  function hasSessionCookie(name) {
    return document.cookie.split("; ").some(cookie => cookie.startsWith(name + "="));
  }

  const interval = setInterval(() => {
    const banner = document.getElementById("onetrust-consent-sdk");

    if (banner) {
      if (hasSessionCookie(cookieName)) {
        banner.style.display = "none";
      } else {
        banner.classList.add("active");
      }

      // Attach click handler AFTER the banner is found
      const closeBtn = banner.querySelector("#onetrust-close-btn-container");
      if (closeBtn) {
        closeBtn.addEventListener("click", function () {
          document.cookie = cookieName + "=true; path=/";
        });
      }

      clearInterval(interval); // Stop checking once the banner is found
    }
  }, 200);
});
*/
 
 
  document.addEventListener('DOMContentLoaded', () => {
    const wrapper = document.querySelector('.scroll-wrapper');
    if (!wrapper) return;

    const container = wrapper.querySelector('.scroll-container');
    if (!container) return;

    let leftArrow, rightArrow;

    function createArrow(direction) {
      const btn = document.createElement('button');
      btn.classList.add('scroll-arrow', direction);
      btn.innerHTML = direction === 'left' ? '' : '';
      btn.addEventListener('click', () => {
        const distance = direction === 'left' ? -300 : 300;
        container.scrollBy({ left: distance, behavior: 'smooth' });
      });
      return btn;
    }

    function updateArrows() {
      const scrollLeft = container.scrollLeft;
      const maxScrollLeft = container.scrollWidth - container.clientWidth;

      if (leftArrow) leftArrow.disabled = scrollLeft <= 0;
      if (rightArrow) rightArrow.disabled = scrollLeft >= maxScrollLeft - 1;
    }

    function checkAndUpdateScrollArrows() {
      const hasOverflow = container.scrollWidth > container.clientWidth;

      // Remove arrows if no overflow
      if (!hasOverflow) {
        if (leftArrow) {
          leftArrow.remove();
          leftArrow = null;
        }
        if (rightArrow) {
          rightArrow.remove();
          rightArrow = null;
        }
      } else {
        // Add arrows if missing
        if (!leftArrow) {
          leftArrow = createArrow('left');
          wrapper.insertBefore(leftArrow, container);
        }
        if (!rightArrow) {
          rightArrow = createArrow('right');
          wrapper.appendChild(rightArrow);
        }
        updateArrows();
      }
    }

    container.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', checkAndUpdateScrollArrows);

    // Initial check
    checkAndUpdateScrollArrows();
  }); 



document.addEventListener('DOMContentLoaded', () => {
  const slideshow = document.querySelector('.product-gallery__carousel');
  if (!slideshow) return;

  const slides = slideshow.querySelectorAll('.product-gallery__media');
  if (slides.length <= 1) return;

  let currentIndex = 0;

  // Create arrows
  const prevBtn = document.createElement('button');
  const nextBtn = document.createElement('button');

  prevBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none"> <path d="M-0.000907403 9.42304L9.42209 -7.67736e-08L11.1785 1.75638L3.5118 9.42304L11.1785 17.0897L9.42209 18.8461L-0.000907403 9.42304Z" fill="#703117"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M18.9225 10.5837H2.25586V8.41699H18.9225V10.5837Z" fill="currentColor"/> </svg>`; // ←
  nextBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none"> <path d="M18.9225 9.42304L9.49954 -7.67736e-08L7.74316 1.75638L15.4098 9.42304L7.74316 17.0897L9.49954 18.8461L18.9225 9.42304Z" fill="currentColor"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M-0.00114012 10.5837H16.6655V8.41699H-0.00114012V10.5837Z" fill="currentColor"/> </svg>`; // ←

  prevBtn.className = 'custom-arrow custom-arrow--prev';
  nextBtn.className = 'custom-arrow custom-arrow--next';

  slideshow.parentNode.insertBefore(prevBtn, slideshow);
  slideshow.parentNode.appendChild(nextBtn);

  // Styles (optional if not in CSS)
 

  function updateButtons() {
    prevBtn.classList.toggle('disabled', currentIndex === 0);
    nextBtn.classList.toggle('disabled', currentIndex >= slides.length - 1);
  }

  function goToSlide(index) {
    if (index < 0 || index >= slides.length) return;
    currentIndex = index;
    const targetSlide = slides[currentIndex];
    slideshow.scrollTo({
      left: targetSlide.offsetLeft,
      behavior: 'smooth'
    });
    updateButtons();
  }

  prevBtn.addEventListener('click', () => goToSlide(currentIndex - 1));
  nextBtn.addEventListener('click', () => goToSlide(currentIndex + 1));

  function updateCurrentIndexFromScroll() {
    const scrollLeft = slideshow.scrollLeft;
    let closestIndex = 0;
    let closestDistance = Infinity;

    slides.forEach((slide, index) => {
      const distance = Math.abs(slide.offsetLeft - scrollLeft);
      if (distance < closestDistance) {
        closestIndex = index;
        closestDistance = distance;
      }
    });

    currentIndex = closestIndex;
    updateButtons();
  }
  // Scroll listener for manual swipe/drag
  slideshow.addEventListener('scroll', () => {
    window.requestAnimationFrame(updateCurrentIndexFromScroll);
  });
  updateButtons();
});
function getStore() {
    var searchType = document.querySelector('input[name="attributes[STORE_SEARCH_KBN]"]:checked');
    if (!searchType) return;

    var typeValue = searchType.value;
    var storeCode = '';
    var storeName = '';
    var selectElement = null;

    if (typeValue === '1') {
        storeCode = document.getElementById('SEARCH_STORE_CD')?.value || '';
        selectElement = document.getElementById('SELECT_SEARCH_STORE_CD');
    } else if (typeValue === '2') {
        storeName = document.getElementById('SEARCH_KEYWORDS')?.value || '';
        selectElement = document.getElementById('SELECT_SEARCH_KEYWORDS');
    }
    // If input is empty, load all stores from cache
    if (!storeCode && !storeName) {
        populateSelectWithStores(selectElement, allStores);
        return;
    }
    
    // call api to get store
	fetch('/apps/proxy/api/store/search?' + new URLSearchParams({
		query: storeCode || storeName,
		search_by: typeValue == 1 ? 'store_code' : 'store_name'
	}), {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	})
	.then(response => response.json())
	.then(data => {
		if (Array.isArray(data) && data.length > 0) {
		  selectElement.innerHTML = '<option value="">こちらから店舗を選択してください</option>';
			data.forEach(item => {
				selectElement.innerHTML += `<option value="${item.store_code}">${item.store_code} - ${item.store_name}</option>`;
			});
		} else {
			selectElement.innerHTML = '<option value="">ー</option>';
    }
	})
	.catch(error => {
		console.error("Error searching stores:", error);
		selectElement.innerHTML = '<option value="">－</option>';
	});
}


// Debounce utility
function debounce(func, wait) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}

// Add event listeners for search inputs
function setupStoreSearchEvents() {
    var storeCdInput = document.getElementById('SEARCH_STORE_CD');
    var keywordInput = document.getElementById('SEARCH_KEYWORDS');
    var radioStoreCd = document.getElementById('SELECT_SEARCH_KBN_STORE_CD');
    var radioKeyword = document.getElementById('SELECT_SEARCH_KBN_KEYWORD');
    
    // Debounced version of getStore
    var debouncedGetStore = debounce(getStore, 500);

    if (storeCdInput) {
        storeCdInput.addEventListener('input', function() {
            if (radioStoreCd && radioStoreCd.checked) {
                debouncedGetStore();
            }
        });
    }
    if (keywordInput) {
        keywordInput.addEventListener('input', function() {
            if (radioKeyword && radioKeyword.checked) {
                debouncedGetStore();
            }
        });
    }
}

$(document).ready(function() {
	$('#SELECT_SEARCH_KBN_STORE_CD').on('change', function() {
    updateStoreAttribute("");
		// Clear the other input first
		document.getElementById('SEARCH_KEYWORDS').value = '';
		// Load all stores to both selects
		setTimeout(function() {
			var selectStoreCd = document.getElementById('SELECT_SEARCH_STORE_CD');
			var selectKeywords = document.getElementById('SELECT_SEARCH_KEYWORDS');
			if (selectStoreCd) populateSelectWithStores(selectStoreCd, allStores);
			if (selectKeywords) populateSelectWithStores(selectKeywords, allStores);
		}, 200);
	});

	$('#SELECT_SEARCH_KBN_KEYWORD').on('change', function() {
    updateStoreAttribute("");
		// Clear the other input first
		document.getElementById('SEARCH_STORE_CD').value = '';
		// Load all stores to both selects
		setTimeout(function() {
			var selectStoreCd = document.getElementById('SELECT_SEARCH_STORE_CD');
			var selectKeywords = document.getElementById('SELECT_SEARCH_KEYWORDS');
			if (selectStoreCd) populateSelectWithStores(selectStoreCd, allStores);
			if (selectKeywords) populateSelectWithStores(selectKeywords, allStores);
		}, 200);
	});

	// Add event listeners for store selection
	$('#SELECT_SEARCH_STORE_CD').on('change', function() {
		const selectedStoreCode = $(this).val();
    updateStoreAttribute(selectedStoreCode ?? "");
	});

	$('#SELECT_SEARCH_KEYWORDS').on('change', function() {
		const selectedStoreCode = $(this).val();
    updateStoreAttribute(selectedStoreCode ?? "");
	});
});

// Global variable to store all stores
var allStores = [];


// Function to populate select with stores
function populateSelectWithStores(selectElement, stores) {
    if (stores && stores.length > 0) {
      selectElement.innerHTML = '<option value="">こちらから店舗を選択してください</option>';
        stores.forEach(item => {
            selectElement.innerHTML += `<option value="${item.store_code}">${item.store_code} - ${item.store_name}</option>`;
        });
    } else {
      selectElement.innerHTML = '<option value="">ー</option>';
    }
}

function moneyWithCurrency(amount, currency = 'JPY', locale = 'ja-JP') {
    const formatted = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
      maximumFractionDigits: 0
    }).format(amount);
    return `${formatted} ${currency}`;
}

function getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      method: 'GET'
    }).then(response => response.json());
}

// Helper function to check if coupon is Hubspot type (first 2 chars: letter + number)
function isHubspotCoupon(couponCode) {
    if (couponCode.length < 2) return false;
    const firstChar = couponCode.charAt(0);
    const secondChar = couponCode.charAt(1);
    return /[a-zA-Z]/.test(firstChar) && /[0-9]/.test(secondChar);
}

// Function to handle Hubspot coupon validation
async function handleHubspotCoupon(couponCode, cartData, totalPrice, errorNote, discountInfo) {
    // Call Hubspot API to validate coupon
    fetch('/apps/proxy/api/coupon/validate', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            store_code: 1999999,
            coupon_code: couponCode,
            cart: cartData,
        })
    })
    .then(response => response.json())
    .then(async data => {
        if (data?.valid) {
            discountInfo.style.display = "block";
            errorNote.innerHTML = "";

            let discountAmount = data.discount_amount ?? 0;
            if (discountAmount == 0) {
                return;
            }
            await updateCartAttributes({
                _has_discount: true,
                _discount_amount: data.discount_amount,
                token: data.token,
                _discount_info: data,
                COUPON_CODE: couponCode
            }, {
              discount: ""
            });
            
            let newTotalPrice = totalPrice - discountAmount;
            if (newTotalPrice < 0) {
                newTotalPrice = 0;
            }
            document.getElementById("cart_total_price").innerHTML = moneyWithCurrency(newTotalPrice);
            document.getElementById("discount_amount").innerHTML = `-${moneyWithCurrency(discountAmount)}`;
    
        } else {
            discountInfo.style.display = "none";
            document.getElementById("cart_total_price").innerHTML = moneyWithCurrency(totalPrice);

            errorNote.innerHTML = data.message;
            errorNote.style.color = 'red'; 
            await resetDiscountInfo();
        }
        document.querySelector('.discount-code-button').classList.remove('btn--loading');
    })
    .catch(error => {
        discountInfo.style.display = "none";
        if (errorNote) {
            errorNote.innerHTML = 'クーポン確認中にエラーが発生しました。';
            errorNote.style.color = 'red';
        }
        resetDiscountInfo();
        document.querySelector('.discount-code-button').classList.remove('btn--loading');
    });
}

// Function to handle Shopify coupon validation
function handleShopifyCoupon(couponCode, cartData, totalPrice, errorNote, discountInfo) {
  updateCartAttributes({
    _has_discount: "",
    token: "",
    _discount_amount: "",
    _discount_info: "",
    SELECT_SEARCH_STORE_CD: "",
    COUPON_CODE: ""
  }, {
    discount: couponCode
  }).then((data) => {
    let isAppliedDiscount = data.discount_codes.filter(discount => discount.code === couponCode && discount.applicable == true).length > 0;
    console.log('isAppliedDiscount', isAppliedDiscount);
    if (isAppliedDiscount) {
      discountInfo.style.display = "block";
      errorNote.innerHTML = "";
      document.getElementById("cart_total_price").innerHTML = moneyWithCurrency(data.total_price/100);

      if (data.total_discount > 0) {
        document.getElementById("discount_amount").innerHTML = `-${moneyWithCurrency(data.total_discount/100)}`;
      } else {
        document.getElementById("discount_amount").innerHTML = `送料無料`;
      }

      document.querySelector('.discount_note').style.display = "block";
    } else {
      discountInfo.style.display = "none";
      if (errorNote) {
        errorNote.innerHTML = '無効なクーポンコードです。';
        errorNote.style.color = 'red';
      }
      document.querySelector('.discount_note').style.display = "none";
    }
  }).catch((error) => {
    discountInfo.style.display = "none";
    if (errorNote) {
      errorNote.innerHTML = '無効なクーポンコードです。';
      errorNote.style.color = 'red';
    }
    document.querySelector('.discount_note').style.display = "none";
    resetDiscountInfo();
  });
}

// Original handleApplyCoupon function with validation
async function handleApplyCouponOriginal() {
    var couponCode = document.getElementById('discount-code')?.value || '';
    var errorNote = document.querySelector('.discount_coupon_note');
    let discountInfo = document.getElementById("discount_info");

    // Clear previous error
    if (errorNote) {
        errorNote.innerHTML = '';
        errorNote.style.color = '';
    }
    
    // Check if coupon code is entered
    if (!couponCode) {
        if (errorNote) {
            errorNote.innerHTML = 'クーポンコードが入力されていません。';
            errorNote.style.color = 'red';
        }
        return;
    }

    var cartData = await getCart();
    let totalPrice = sessionStorage.getItem('subtotalPrice');
    document.querySelector('.discount-code-button').classList.add('btn--loading');

    // Determine coupon type and handle accordingly
    if (isHubspotCoupon(couponCode)) {

        document.querySelector('.discount_note').style.display = "none";
        // Handle as Hubspot coupon (first 2 chars: letter + number)
        await handleHubspotCoupon(couponCode, cartData, totalPrice, errorNote, discountInfo);
    } else {
        // Handle as Shopify coupon (all other cases)
        await handleShopifyCoupon(couponCode, cartData, totalPrice, errorNote, discountInfo);
        document.querySelector('.discount-code-button').classList.remove('btn--loading');

    }
}

function resetDiscountInfo() {
    updateCartAttributes({
        _has_discount: "",
        token: "",
        _discount_amount: "",
        _discount_info: "",
        SELECT_SEARCH_STORE_CD: "",
        COUPON_CODE: ""
    }, {
      discount: ""
    })
}

function updateCart(attributes = {}, params = {}) {
    // Prepare the update data
    const updateData = {
        attributes: attributes,
        ...params
    };
    
    // Update cart via AJAX
    return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateData)
    })
    .then(response => response.json())
    .then(updatedCart => {
        // Trigger cart update events
        document.dispatchEvent(new CustomEvent('cartUpdated', { 
            detail: { cart: updatedCart } 
        }));
        
        return updatedCart;
    })
    .catch(error => {
        console.error('Error updating cart:', error);
        throw error;
    });
}

// Helper function to update specific cart attributes
function updateCartAttributes(attributes, params = {}) {
    return updateCart(attributes, params);
}


// Debounced version of handleApplyCoupon
const debouncedHandleApplyCoupon = debounce(handleApplyCouponOriginal, 500);

// Global function for onclick (for backward compatibility)
window.handleApplyCoupon = debouncedHandleApplyCoupon;


// Function to remove applied coupon
function removeAppliedCoupon() {
    // Clear coupon code input
    const couponInput = document.getElementById('discount-code');
    if (couponInput) {
        couponInput.value = '';
    }
    
    // Clear error/success message
    const errorNote = document.querySelector('.discount_coupon_note');
    if (errorNote) {
        errorNote.innerHTML = '';
        errorNote.style.color = '';
    }
}


// Call this function when DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
    setupStoreSearchEvents(); // keep the old function


    // remote note attribute discount 
    resetDiscountInfo();
    
    // Setup coupon button with debounce
    const couponButton = document.querySelector('.discount-code-button');
    if (couponButton) {
        couponButton.addEventListener('click', debouncedHandleApplyCoupon);
    }
});

// Function to update the SELECT_SEARCH_STORE_CD attribute via API
function updateStoreAttribute(storeCode) {

	// Update cart attribute
	updateCartAttributes({
		SELECT_SEARCH_STORE_CD: storeCode ?? "",
	}).then(() => {
		console.log('Store attribute updated successfully:', storeCode);
	}).catch(error => {
		console.error('Error updating store attribute:', error);
	});

}

/*custom-banner-slider.liquid*/
document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('.custom-banner-slider-container').forEach(function (sliderWrap) {
    var slider = sliderWrap.querySelector('.custom-banner-slider');
    if (!slider) return;

    new Swiper(slider, {
      observer: true,
      observeParents: true,
      loop: true,
      slidesPerView: 2.2,
      spaceBetween: 12,
      navigation: {
        nextEl: sliderWrap.querySelector('.custom-banner-slider__next'),
        prevEl: sliderWrap.querySelector('.custom-banner-slider__prev'),
        disabledClass: 'k_swiper_disabled'
      },
      pagination: {
        el: sliderWrap.querySelector('.custom-banner-slider__pagination'),
        type: 'bullets',
        clickable: true
      },
      breakpoints: {
        769: {
          slidesPerView: 3,
          spaceBetween: 24
        }
      }
    });
  });
});